import { render, staticRenderFns } from "./CurrentAddressDisplay.vue?vue&type=template&id=06dee7ef&scoped=true"
import script from "./CurrentAddressDisplay.vue?vue&type=script&lang=js"
export * from "./CurrentAddressDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dee7ef",
  null
  
)

export default component.exports